import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';

import useTokenValidation from '../hook/useTokenValidation';

const ProtectedRoute = ({ children }) => {

  const { validateAndHandleToken } = useTokenValidation();
  const location = useLocation();

    useEffect(() => {
        // Validate token when pathname changes
        validateAndHandleToken().catch(err => {
            console.error('Token validation error:', err);
        });
    }, [validateAndHandleToken, location.pathname]);
    
  return <>
    {children}
    <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
  </>
  ;
};

export default ProtectedRoute;